<template>
    <VJoyBadge bulletpoint :variant="statusVariant" :label="statusLabel" />
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyBadge} from '@maltjoy/core-vue';
    import {ProjectStatus} from '@api';

    const props = defineProps<{
        status: ProjectStatus;
    }>();

    const {t} = useTranslation();

    const statusVariant = computed(() => {
        switch (props.status) {
            case ProjectStatus.ToApprove:
                return 'pink';
            case ProjectStatus.PreApproved:
                return 'yellow';
            case ProjectStatus.AcceptanceBlocked:
                return 'yellow';
            case ProjectStatus.PaymentOnHold:
                return 'red';
            case ProjectStatus.Upcoming:
                return 'info';
            case ProjectStatus.InProgress:
                return 'dark-blue';
            case ProjectStatus.Delivered:
                return 'green';
            case ProjectStatus.Ended:
                return 'gray';
            case ProjectStatus.Canceled:
                return 'red';
            default:
                return 'gray';
        }
    });

    const statusLabel = computed(() => t(`projectclient.projectlist.table.status.value.${props.status}`).toLowerCase());
</script>
